import { faker } from '@faker-js/faker'

export const CREATE_EXPORT_REQUEST_MOCK = {
  data: {
    initiateExportRequest: {
      id: faker.string.uuid(),
      status: 'created',
    },
  },
}

export const ACTIVE_EXPORT_RESPONSE_MOCK = {
  data: {
    activeExportRequests: [
      {
        id: faker.string.uuid(),
        userId: faker.string.uuid(),
        status: 'created',
        export: faker.lorem.word(),
        url: faker.internet.url(),
      },
      {
        id: faker.string.uuid(),
        userId: faker.string.uuid(),
        status: 'created',
        export: faker.lorem.word(),
        url: faker.internet.url(),
      },
    ],
  },
}

export const ACTIVE_EXPORT_REQUEST_RESPONSE_MOCK = {
  data: {
    activeExportRequest: {
      id: faker.string.uuid(),
      userId: faker.string.uuid(),
      status: 'processed',
      export: faker.lorem.word(),
      url: faker.internet.url(),
    },
  },
}

export const DELETE_EXPORT_REQUEST_MOCK = {
  data: {
    deleteExportRequest: {
      id: faker.string.uuid(),
    },
  },
}
